var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LegalPage',{attrs:{"title":"About Us","intro":"gbwhatsdroid.com is an independent information resource focused on helping Android users understand GBWhatsApp before downloading an APK.","sections":_vm.sections,"email":"contact@gbwhatsdroid.com","page-name":"about"}})
}
var staticRenderFns = []

export { render, staticRenderFns }